export default __webpack_public_path__ + "static/media/46k.d535e84d.md";